import { EStarSize, Stars } from '@cian/frontend-reviews-components';
import { UIHeading4, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './styles.css';

export interface IAuthorProps {
  name: string;
  date: string;
  rating?: number;
}

export const Author: React.FC<IAuthorProps> = ({ name, date, rating }) => {
  return (
    <div data-testid="Author" className={style['container']}>
      <div className={style['name']}>
        <UIHeading4>{name}</UIHeading4>
      </div>
      <div className={style['info']}>
        {rating !== undefined && (
          <div className={style['stars']}>
            <Stars size={EStarSize.M} value={rating} />
          </div>
        )}
        <UIText3>{date}</UIText3>
      </div>
    </div>
  );
};
